import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  DriverRegistrationResponseDTO
} from '../../authentication/connection/interfaces/apiInterfaces';


export class GetDriversByVehicleCommand extends IRequestCommand<
  IGetDriverResponse,
  ErrorDetails,
  IGetDriversByVehiclesCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'driver/carrier/{carrierEmail}/vehicle/{vehicleId}';
  public override setParameters(parameters: IGetDriversByVehiclesCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierEmail}',
      parameters.carrierEmail.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{vehicleId}',
      parameters.vehicle.toString()
    );
  }
}

export interface IGetDriversByVehiclesCommandParameters
  extends ICommandParameters {
  carrierEmail?: string;
  vehicle?: number;
}

export interface IGetDriverResponse
  extends DriverRegistrationResponseDTO,
  ICommandResponse { }
